const getXero = (app, endPoint) => {
  return app.service(endPoint);
};

export const authorise = async (app, id, params = {}) => {
  const api = getXero(app, 'xero/authorise');
  const result = await api.get(id, params);
  if (result.authUrl) {
    window.location = result.authUrl;
  }
};

export const disconnect = async (app, id, params = {}) => {
  const api = getXero(app, 'xero/authorise/disconnect');
  const result = await api.get(id, params);
  return result;
};

export const fetchAccountDropdown = (app, params = {}) => {
  const api = getXero(app, 'xero/account');
  return api.find(params);
};

export const saveAccount = (app, data, params = {}) => {
  const api = getXero(app, 'xero/account');
  return api.create(data, params);
};

export const fetchTaxRateDropdown = (app, params = {}) => {
  const api = getXero(app, 'xero/tax_rate');
  return api.find(params);
};

export const saveTaxRate = (app, data, params = {}) => {
  const api = getXero(app, 'xero/tax_rate');
  return api.create(data, params);
};

export const manualSync = (app, id, params = {}) => {
  const api = getXero(app, 'xero/integrate/summary/' + id);
  return api.create(null, params);
}

export const validate = async (app, params = {}) => {
  const { id } = params;
  const api = getXero(app, 'xero/authorise/validate');
  const result = await api.get(id, params);
  return result.valid;
};
